/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Settings_Nav_SecurityInputs */



/**
* | output |
* | --- |
* | "Security" |
*
* @param {Partner_Settings_Nav_SecurityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_settings_nav_security = /** @type {((inputs?: Partner_Settings_Nav_SecurityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Settings_Nav_SecurityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sicherheit")
	return /** @type {LocalizedString} */ ("Security")
});